import { UnleashFeatureFlag } from '@ben/shared/constants/feature-flags';
import useFeatureFlag from '@ben/shared/hooks/use-feature-flag';
import Beneficiaries, { type BeneficiariesProps } from './beneficiaries';
import LegacyBeneficiaries from './beneficiaries.old';

// Single fork for the beneficiaries benefit section, shared by EA and ECC: one
// flag read decides legacy vs the new experience. Legacy renders unchanged.
const BeneficiariesSection = (props: BeneficiariesProps) => {
  const { isEnabled } = useFeatureFlag(
    UnleashFeatureFlag.new_beneficiary_flow_enabled
  );

  return isEnabled ? (
    <Beneficiaries {...props} />
  ) : (
    <LegacyBeneficiaries {...props} />
  );
};

export default BeneficiariesSection;
